<script setup lang="ts">
import { ref } from "vue";
import LoginPage from "./components/LoginPage.vue";
import SetBoothKey from "./components/SetBoothKey.vue";
import BaseInformation from "./components/BaseInformation.vue";
import ShowServices from "./components/ShowServices.vue";
import GenericButton from "./components/ui/GenericButton.vue";
import GenericModal from "./components/ui/GenericModal.vue";
import { personBaseData } from "./utils/interfaces";
import { useIdleTimer } from "@/composables/useIdleTimer";

enum View {
  Login = "login",
  SetBoothKey = "setBoothKey",
  BaseInformation = "baseInformation",
  ShowServices = "ShowServices",
}

const currentView = ref<View>(View.Login);
const personData = ref({} as personBaseData);
const showIdleModal = ref(false);
const timeBack = ref(15);
const isReseted = ref(false);

const { pause, resume, setTimeoutValue } = useIdleTimer({
  onIdle: () => {
    showIdleModal.value = true;
    const setTimeBack = () => {
      setTimeout(() => {
        if (isReseted.value) {
          showIdleModal.value = false;
          timeBack.value = 15;
          isReseted.value = false;
          return;
        }
        if (timeBack.value === 0) {
          showIdleModal.value = false;
          timeBack.value = 15;
          changeView(View.BaseInformation);
          return;
        }
        timeBack.value = timeBack.value - 1;
        setTimeBack();
      }, 1000);
    };
    pause();
    setTimeBack();
  },
});

async function handleClick() {
  if (
    process.env.VUE_APP_DEBUG !== "true" &&
    document.documentElement.requestFullscreen
  ) {
    try {
      await document.documentElement.requestFullscreen();
      document.addEventListener("contextmenu", function (e) {
        e.preventDefault();
      });

      document.addEventListener("keydown", function (e) {
        if (!e || !e.key) return;
        const key = e.key.toLowerCase();

        // Bloquea F12
        if (key === "f12") {
          e.preventDefault();
          console.log("F12 bloqueada");
        }

        // Bloquea Ctrl+Shift+I
        if (e.ctrlKey && e.shiftKey && key === "i") {
          e.preventDefault();
          console.log("Ctrl+Shift+I bloqueado");
        }

        // Bloquea Ctrl+Shift+C
        if (e.ctrlKey && e.shiftKey && key === "c") {
          e.preventDefault();
          console.log("Ctrl+Shift+C bloqueado");
        }

        // Bloquea Ctrl+U
        if (e.ctrlKey && key === "u") {
          e.preventDefault();
          console.log("Ctrl+U bloqueado");
        }

        // Bloquea Escape
        if (key === "escape" || e.keyCode === 27) {
          e.preventDefault();
          e.stopPropagation();
          console.log("Tecla Escape bloqueada");
        }
      });
    } catch (err) {
      console.error("Error al intentar pantalla completa:", err);
    }
  }
}

async function resetIdleTimer() {
  isReseted.value = true;
  resume();
}

function changeView(view: View, data?: any) {
  currentView.value = view;
  if (data) {
    const { afiliacion } = data;
    const { numeroPlanAsociado, referencia, idPersona } = afiliacion;
    personData.value.numeroPlanAsociado = numeroPlanAsociado;
    personData.value.referencia = referencia;
    personData.value.idPersona = idPersona;
    personData.value.nroOrden = data.nroOrden;
    personData.value.email = data.email;
  }
}
</script>

<template>
  <div
    class="h-screen w-screen overflow-auto flex items-center justify-center"
    @click="handleClick"
  >
    <LoginPage v-if="currentView === View.Login" @change-view="changeView" />
    <SetBoothKey
      v-else-if="currentView === View.SetBoothKey"
      @change-view="changeView"
    />
    <BaseInformation
      v-else-if="currentView === View.BaseInformation"
      @change-view="changeView"
      @pause-timer="pause"
    />
    <ShowServices
      v-else
      @change-view="changeView"
      @set-timeout="setTimeoutValue"
      @resume-timer="resume"
      @pause-timer="pause"
      :personData="personData"
      allow="camera; microphone"
      allowfullscreen
    />
    <GenericModal
      v-if="showIdleModal"
      class="flex flex-col items-cente rounded p-6 z-index-[9999]"
      :openOnMount="true"
      id="idleModal"
    >
      <h3 class="text-2xl font-bold">Se ha detectado inactividad</h3>
      <p class="text-xl text-center">¿Continua ahí?</p>
      <template v-slot:actions>
        <div class="flex justify-between items-center h-full">
          <span class="text-red-500"
            >Se terminará la sesión en {{ timeBack }} segundos</span
          >
          <GenericButton class="px-3 py-1.5" @click="resetIdleTimer"
            >Sí</GenericButton
          >
        </div>
      </template>
    </GenericModal>
  </div>
</template>

<style scoped></style>
